// src/services/emailService.js
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

export class EmailService {
  constructor() {
    this.sendEmailFunction = httpsCallable(functions, 'sendEmail');
  }

  async sendWelcomeEmail(bookId, userEmail, userName, customData = {}) {
    try {
      const result = await this.sendEmailFunction({
        templateType: 'welcome',
        recipientEmail: userEmail,
        recipientName: userName,
        bookId,
        customData
      });
      return result.data;
    } catch (error) {
      console.error('Failed to send welcome email:', error);
      throw error;
    }
  }

  async sendBookingConfirmation(bookId, userEmail, userName, bookingData) {
    try {
      const result = await this.sendEmailFunction({
        templateType: 'booking_confirmation',
        recipientEmail: userEmail,
        recipientName: userName,
        bookId,
        customData: {
          bookingDetails: bookingData,
          eventTitle: bookingData.eventTitle,
          eventDate: bookingData.eventDate,
          eventTime: bookingData.eventTime,
          location: bookingData.location,
          confirmationCode: bookingData.confirmationCode
        }
      });
      return result.data;
    } catch (error) {
      console.error('Failed to send booking confirmation:', error);
      throw error;
    }
  }

  async sendReminder(bookId, userEmail, userName, reminderData) {
    try {
      const result = await this.sendEmailFunction({
        templateType: 'reminder',
        recipientEmail: userEmail,
        recipientName: userName,
        bookId,
        customData: {
          eventTitle: reminderData.eventTitle,
          eventDate: reminderData.eventDate,
          eventTime: reminderData.eventTime,
          location: reminderData.location,
          reminderType: reminderData.reminderType,
          joinLink: reminderData.joinLink
        }
      });
      return result.data;
    } catch (error) {
      console.error('Failed to send reminder:', error);
      throw error;
    }
  }

  async sendCompletionCertificate(bookId, userEmail, userName, completionData) {
    try {
      const result = await this.sendEmailFunction({
        templateType: 'completion_certificate',
        recipientEmail: userEmail,
        recipientName: userName,
        bookId,
        customData: {
          bookName: completionData.bookName,
          completionData: {
            score: completionData.score,
            timeSpent: completionData.timeSpent,
            interactions: completionData.interactions
          },
          certificateUrl: completionData.certificateUrl,
          recommendedBooks: completionData.recommendedBooks
        }
      });
      return result.data;
    } catch (error) {
      console.error('Failed to send completion certificate:', error);
      throw error;
    }
  }

  async sendCustomNotification(bookId, userEmail, userName, notificationData, brandingOptions = {}) {
    try {
      const result = await this.sendEmailFunction({
        templateType: 'custom_notification',
        recipientEmail: userEmail,
        recipientName: userName,
        bookId,
        customData: {
          title: notificationData.title,
          message: notificationData.message,
          actionButton: notificationData.actionButton,
          customStyling: notificationData.customStyling
        },
        brandingOptions
      });
      return result.data;
    } catch (error) {
      console.error('Failed to send custom notification:', error);
      throw error;
    }
  }

  async sendInteractionSummary(bookId, userEmail, userName, summaryData) {
    try {
      const result = await this.sendEmailFunction({
        templateType: 'interaction_summary',
        recipientEmail: userEmail,
        recipientName: userName,
        bookId,
        customData: {
          bookName: summaryData.bookName,
          period: summaryData.period,
          summaryData: {
            interactions: summaryData.interactions,
            timeSpent: summaryData.timeSpent,
            completedSections: summaryData.completedSections
          },
          continueUrl: summaryData.continueUrl
        }
      });
      return result.data;
    } catch (error) {
      console.error('Failed to send interaction summary:', error);
      throw error;
    }
  }
}

export const emailService = new EmailService();